module.exports = __webpack_public_path__ + "static/media/SunDark.44c22506.svg";